import Contract from "./Contract";

const Index = () => {

    
    return (
        <>
            <Contract title={"Due For Force Selling"} settlementType={"1"}/>
        </>
    );
};

export default Index;
